import Axios from "axios";
import router from './../../router'
import USER_ROLE from "../../enums/user-role";

export default {
    namespaced: true,
    state: {
        auth_user: null,
        errors: [],
        base_url: '/api',
        isAuthPending: false,
        single: {
            id: null,
            email: null,
            password: null,
            password_confirmation: null,
        }
    },
    getters: {
        base_url(state) {
            return state.base_url;
        },
        auth_user(state) {
            return state.auth_user;
        },
        is_auth_pending(state) {
            return state.is_auth_pending
        },
        isRoot(state, getters) {
            if(getters.auth_user) {
                return Number(getters.auth_user.role) === Number(USER_ROLE.values.ROOT.description);
            }

            return false;
        },
    },
    actions: {
        async getAuthUser( { dispatch, getters, commit, state } ) {
            commit('SET_AUTH_PENDING', true);
            const response = await Axios.get(getters.base_url + '/auth/user?include=settings,corporation,corporation.settings');
            commit('SET_AUTH_USER', response.data.data);

            return response.data.data;
        },
        login( {commit, dispatch, state, getters}, credentials ) {
            state.errors = [];

            commit('SET_AUTH_PENDING', true);

            Axios.get('/sanctum/csrf-cookie').then(response => {
                Axios.post(getters.base_url + '/login', credentials).then(response => {
                    dispatch('getAuthUser');
                    window.location.replace('/admin');
                })
                    .catch(error =>{
                        console.warn(error);
                        if(error.status === 422) {
                            state.errors = error.data.errors;
                        }
                    }) // mostly credentials didn't work
                    .finally( () => commit('SET_AUTH_PENDING', false))
            })
            .catch(error => console.warn(error));
        },
        logout( { commit, getters } ) {
            commit('SET_AUTH_PENDING', true);

            Axios.post(getters.base_url + '/logout')
                .then(response => {
                    commit('SET_AUTH_USER', null);
                    window.location.replace('/login');
                })
                .catch(error => console.warn(error))
                .finally( () => commit('SET_AUTH_PENDING', false))
        },
    },
    mutations: {
        SET_AUTH_USER(state, auth_user) {
            state.auth_user = auth_user;
        },
        SET_AUTH_PENDING(state, auth_pending) {
            state.isAuthPending = auth_pending;
        }
    },
}
